<div class="card mainContent">
    <div class="cardTitle">
        <h2>{{ 'exports.imports-runner.bulkAddIds.modal.title' | translate }}</h2>
    </div>
    <div class="cardContent">
        <p>{{ 'exports.imports-runner.bulkAddIds.modal.infoText' | translate }}</p>
        <div class="channelIdsInputWrapper" [formGroup]="channelIdsForm">
            <textarea formControlName="channelIds"></textarea>
            <p class="support-text">{{ 'exports.imports-runner.importChannelIdsSupportText' | translate }}</p>
        </div>
    </div>

    <div class="cardFooter">
        <div class="buttonArea stickyBottom">
            <button type="button" class="button primary" (click)="onConfirmButtonClicked()">
                {{ 'generalKeywords.confirm' | translate }}
            </button>
            <button type="button" class="button" (click)="closeModalInstance(null)">{{ 'generalKeywords.cancel' | translate }}</button>
        </div>
    </div>
</div>
